import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { INSUFFICIENT_PERMISSION_MESSAGE } from '../permissions/constants';
import { hideInsufficientPermissionModal } from '../store/permissionModalSlice';

export default function InsufficientPermissionModal() {
  const dispatch = useDispatch();
  const open = useSelector((state) => state.permissionModal.open);

  const handleClose = () => {
    dispatch(hideInsufficientPermissionModal());
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Insufficient permissions</DialogTitle>
      <DialogContent>
        <Typography>{INSUFFICIENT_PERMISSION_MESSAGE}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
